import { call, put } from "redux-saga/effects";
import devisService from "../services/devisService";
import { createModule } from "saga-slice";
import { get } from "lodash";

const initialState = {
    list: [],
    newDevisNumber: null,
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 6, // Size of each page
};

const devisSlice = createModule({
    name: 'devis',
    initialState,
    reducers: {
        generatePdfRequest: (state) => {
            state.loading = true;
        },
        list: (state) => {
            state.loading = true;
        },
        filter: (state, action) => {
            state.loading = true;
        },
        add: (state) => {
            state.loading = true;
        },
        delete: (state) => {
            state.loading = true;
        },
        accepterDevis: (state) => {
            state.loading = true;
        },
        fetchNewDevisNumber: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.list = payload.body;

        },
        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state, action) => {
            state.isFetching = false;
            state.error = action || "An error occurred";
        },
        generatePdfSuccess: (state) => {
            state.loading = false;
        },
        generatePdfFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },
        deleteSuccess: (state, action) => {
            state.loading = false;
        },
        deleteFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },
        updateDevisRequest: (state) => {
            state.loading = true;
        },
        setNewDevisNumber: (state, action) => {
            state.newDevisNumber = action;
            state.loading = false;
        },
    },
    sagas: (A) => ({
        *[A.list]({ payload }) {
            try {
                console.log(payload);
                const data = yield call(devisService.list, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload.onSuccess) {
                    payload.onSuccess();
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.accepterDevis]({ payload }) {
            try {
                console.log(payload);
                const data = yield call(devisService.accepterDevis, payload.id);
                yield put(A.finishFetching());
                if (payload.onSuccess) {
                    payload.onSuccess();
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.filter]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(devisService.filter, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.add]({ payload }) {
            try {
                console.log(payload);
                const data = yield call(devisService.add, payload.data);
                yield put(A.finishFetching());
                payload.onSuccess(data);
                //yield put(A.generatePdfRequest(data.data.body)); // Dispatch the action to generate the PDF after invoice creation
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.generatePdfRequest]({ payload }) {
            try {
                const pdfData = yield call(devisService.generatePdf, payload);
                const blob = new Blob([pdfData], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank'); // Open the PDF in a new window
                yield put(A.generatePdfSuccess());
            } catch (error) {
                yield put(A.generatePdfFailure(error.message));
            }
        },
        *[A.delete]({ payload }) {
            try {
                yield call(devisService.delete, payload.id);
                yield put(A.deleteSuccess(payload));
                yield call(payload.onSuccess);
            } catch (e) {
                yield put(A.deleteFailure(e.message));
            }
        },
        *[A.fetchNewDevisNumber]() {
            try {
                const { data } = yield call(devisService.fetchNewDevisNumber);
                yield put(A.setNewDevisNumber(data.body));
            } catch (error) {
                yield put(A.setError(error.message));
            }
        },
        *[A.updateDevisRequest]({ payload }) {
            try {
                const data = yield call(devisService.updateDevis, payload.id, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
    }),

});

export default devisSlice;
export const devisActions = devisSlice.actions;